// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"2f565f78","430":"88b21710","453":"a0c665bb","552":"ff8b5f3f","648":"f767e291","787":"9cd8641f","815":"26f437f1","897":"cf082d62","922":"e5cc0cfa","956":"66116614","965":"3945732b"}[chunkId] + ".chunk.js";
};